// Auto-generated by the generator
// Don't manually edit this file

// @flow

import {initEffect} from './init'
import {watchLocationEffect} from './watchLocation'
import {searchPlaceEffect} from './searchPlace'
import {onClickPlaceEffect} from './onClickPlace'
import {enterMapEffect} from './enterMap'
import {searchByTextEffect} from './searchByText'
import {searchByLocationEffect} from './searchByLocation'
import {enterMapPlaceEffect} from './enterMapPlace'

export const mapEffects = [
  initEffect,
  watchLocationEffect,
  searchPlaceEffect,
  onClickPlaceEffect,
  enterMapEffect,
  searchByTextEffect,
  searchByLocationEffect,
  enterMapPlaceEffect,
]
